import state from './template/template.state'
import getters from './template/template.getters'
import mutations from './template/template.mutations'
import actions from './template/template.actions'


export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
